<template>
    <div class="content" id="contentRef" :style="{height:showHeight}">
      <van-swipe
        :style="{height:showHeight}"
        :autoplay="false"
        :loop="false"
        :show-indicators="false"
        :stop-propagation="false"
        :touchable="true"
        ref="swiper"
        :duration="0"
        @change="onChange"
      >
        <van-swipe-item
          v-for="item in contentList"
          :key="item.id"
        >
          <div class="content__icon">
            <div class="content__icon__wrapper left">
              <span
                class="iconfont content__icon__wrapper__item"
                @click="routeBack"
              >
              &#xe6a0;
              </span>
            </div>
            <div class="content__icon__wrapper left" @click="changeFontSizeSubtract">
              <span
                class="iconfont icon__subtract content__icon__wrapper__item"
              >
                &#xe629;
              </span>
            </div>
            <div class="content__icon__wrapper left" @click="changeFontSizeAdd">
              <span
                class="iconfont icon__add content__icon__wrapper__item"
              >
              &#xe681;
              </span>
            </div>
            <div class="content__icon__wrapper left" @click="backTop">
              <span
                class="iconfont icon__add content__icon__wrapper__item"
              >
              &#xe63d;
              </span>
            </div>
          </div>
          <div class="content__item">
            <div class="content__img image-container" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" v-if="item.typeName === '图片'">
              <img :style="{ transform: `scale(${scale})` }" alt="Zoomable Image" />
            </div>
            <div class="content__text" v-else>
              <h4 class="content__text__h4">{{item.primersTitle}}</h4>
              <h3 class="content__text__h3">{{item.title}}</h3>
              <h4 class="content__text__h4">{{item.subtitle}}</h4>
              <p class="content__text__p">
                <span>日期：{{item.pageDate}}</span>
                <span>【{{item.pageNum}}版：{{item.pageName}}】</span>
              </p>
              <p class="content__text__author" v-if="item.author">
                <span>【作者：{{item.author}}】</span>
              </p>
              <div
                class="content__text__img image-container"
                @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd"
                v-for="(itemPictures, index) in item.attachedPictures"
                :key="index"
              >
                <img
                  :style="{ transform: `scale(${scale})` }" alt="Zoomable Image"
                  :src="`${imgUrl}/${itemPictures.accessName}/${itemPictures.accessName}/${itemPictures.outfilePath}/${itemPictures.originalFile}`"
                />
                <p v-html="itemPictures.picExplain"  class="left-align-text"></p>
              </div>
              <!-- <div
                  class="content__text__img"
                  v-for="(itemPictures, index) in attachedPictures"
                  :key="index"
              >
                  <img
                      :src="`${imgUrl}/${itemPictures.accessName}/${itemPictures.accessName}/${itemPictures.outfilePath}/${itemPictures.originalFile}`"
                  />
                  <div v-html="itemPictures.picExplain"></div>
              </div> -->

              <div :id="item.id" class="content__text__content" ref="text" v-html="item.content"></div>
            </div>
          </div>
          <Voice :voiceText="item.voiceText"/>
        </van-swipe-item>
      </van-swipe>
      <div class="content__left" @click="changePrev"></div>
      <div class="content__next" @click="changeNext"></div>
    </div>
    <!-- <Daily
      v-if="periodical == 0"
      :newspaper="newspaper"
      :newspaperId="newspaperId"
      @emit-home="getDailyPageList"
      @getContentDirectory="getContentDirectory"
    /> -->
    <Periodical
        :newspaper="newspaper"
        :newspaperId="newspaperId"
        @emit-content="getDailyPageList"
    />
</template>

<script>
import Periodical from '../components/Periodical'
// import Daily from '../components/Daily'
import Voice from './Voice'
import { ref, watch, onMounted, computed, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { get } from '../../utils/request'
import Hammer from 'hammerjs'

export default {
  name: 'Content',
  components: { Periodical, Voice },
  setup (context) {
    const count = ref(0.5)
    // const length = ref()
    const text = ref([])
    const swiper = ref()
    const voiceText = ref('')
    const contentText = ref([])
    const contentList = ref([])
    const contentItem = ref()
    const typeName = ref()
    const newspaper = ref()
    const swiperIndex = ref()
    const changeIndex = ref()
    const newsId = ref()
    const newspaperId = ref('')
    const pageInfo = ref({})
    const pageNewsArea = ref([])
    const attachedPictures = ref([])
    const content = ref()
    const showHeight = ref()
    const periodical = ref()
    const areaIndex = ref()
    const title = ref()
    const emitDirectoryList = ref([])
    const contentDirectoryList = ref([])
    const attachedList = ref()
    const contentTitleList = ref([])
    const videoElement = ref([])
    const pageId = ref('')
    // const contentPicList = ref([])
    const Base64 = require('js-base64').Base64
    const imgUrl = process.env.VUE_APP_UPLOAD_URL
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    newspaper.value = route.params.accessName
    newsId.value = route.params.newsid
    pageId.value = route.params.pageId
    console.log(newsId.value)
    store.dispatch('getNewspaper', newspaper.value)
    // const directoryList = computed(() => store.state.directoryList)
    const directoryList = ref([])
    // debugger
    console.log(directoryList.value)
    const contentIndex = computed(() => store.state.contentIndex)
    const contentTitle = computed(() => store.state.contentTitle)
    const getDirectoryList = async () => {
      const url = `/tableNewsController/getTableNewsList?ids=${pageId.value}&accessName=${newspaper.value}`
      const result = await get(url)
      directoryList.value = result.list
    }
    getDirectoryList()
    const isDirectoryList = () => {
      if (directoryList.value !== undefined) {
        contentDirectoryList.value = directoryList.value
        // debugger
      }
      console.log(contentDirectoryList.value)
      contentDirectoryList.value.map((item, index) => {
        const contentItem = {
          contentIndex: index,
          title: item.title
        }
        contentTitleList.value.push(contentItem)
        // store.dispatch('getContentTitle', contentTitleList.value[0].title)
        if (item.id === newsId.value) {
          areaIndex.value = index
          title.value = item.title
          // debugger
          store.dispatch('getContentTitle', title.value)
          store.dispatch('getActiveIndex', index)
        }
        getContentText(item.id, item.accessName)
      })
    }
    watch(
      () => directoryList.value,
      () => {
        isDirectoryList()
      })
    onMounted(() => {
      window.fullHeight = document.documentElement.clientHeight
      showHeight.value = window.fullHeight - 54 + 'px'
    })
    onBeforeUpdate(() => {
      swiper.value.swipeTo(areaIndex.value)
      // debugger
      document.title = contentTitle.value
      const contentRef = document.querySelector('#contentRef')
      var hammer = new Hammer(contentRef)
      hammer.get('pinch').set({ enable: true })
      hammer.on('pinchin', e => {
        const currentDom = document.querySelector('#' + newsId.value)
        alert(currentDom)
        if (count.value > 0.47) {
          count.value -= 0.05
          currentDom.style.fontSize = count.value + 'rem'
        }
      })
      hammer.on('pinchout', e => {
        const add = document.querySelector('#' + newsId.value)
        alert(add)
        if (count.value < 0.57) {
          count.value += 0.05
          add.style.fontSize = count.value + 'rem'
        }
      })
    })
    const getContentText = async (id, accessName) => {
      const url = `/tableNewsController/getTableNews?id=${id}&accessName=${accessName}`
      // const url = '/tableNewsController/getTableNews?id=FDF33E50D4D549C9B05F636C06690E3C&accessName=xlglrb'
      const result = await get(url)
      contentText.value = result.data
      const itemId = contentText.value.id
      const title = contentText.value.title
      const orderNumber = contentText.value.orderNumber
      const primersTitle = contentText.value.primersTitle
      const subtitle = contentText.value.subtitle
      const pageDate = contentText.value.pageDate
      const pageNum = contentText.value.pageNum
      const pageName = contentText.value.pageName
      const author = contentText.value.author
      content.value = Base64.decode(contentText.value.content)
      voiceText.value = (title + primersTitle + subtitle + content.value).replace(/<[^>]+>/g, '')
      typeName.value = contentText.value.typeName
      attachedPictures.value = []
      result.data.attachedPictures.map((item, index) => {
        const picExplain = Base64.decode(item.picExplain)
        attachedList.value = {
          accessName: item.accessName,
          outfilePath: item.outfilePath,
          originalFile: item.originalFile,
          picExplain: picExplain
        }
        attachedPictures.value.push(attachedList.value)
      })
      contentItem.value = {
        orderNumber: orderNumber,
        id: itemId,
        title: title,
        pageDate: pageDate,
        pageNum: pageNum,
        pageName: pageName,
        author: author,
        primersTitle: primersTitle,
        subtitle: subtitle,
        content: content.value,
        voiceText: voiceText.value,
        typeName: typeName.value,
        attachedPictures: attachedPictures.value
      }
      contentList.value.push(contentItem.value)
      contentList.value.sort(compare('pageNum'))
      // contentList.value.sort(compare('orderNumber'))
    }
    const getNewspaper = async () => {
      const url = `/newspaperController/getNewspaper?name=${newspaper.value}`
      const result = await get(url)
      periodical.value = result.data.periodical
      newspaperId.value = result.data.id
      store.dispatch('getPeriodical', periodical.value)
    }
    getNewspaper()
    const getContentDirectory = (data) => {
      emitDirectoryList.value = data
    }
    const getDailyPageList = (data) => {
      swiperIndex.value = data.index
      pageInfo.value = data
      pageNewsArea.value = JSON.parse(pageInfo.value.newsArea)
      store.dispatch('getSwiperIndex', swiperIndex)
    }
    const onChange = (swiperIndex) => {
      for (let i = 0; i < videoElement.value.length; i++) {
        if (changeIndex.value > swiperIndex && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
        if (changeIndex.value < swiperIndex && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
      changeIndex.value = swiperIndex
      contentTitleList.value.map((item, index) => {
        if (swiperIndex === index) {
          document.title = item.title
        }
      })
      // console.log(videoElement.value)
      // debugger
    }
    // 排序方法
    const compare = (key) => {
      return (a, b) => {
        var val1 = a[key]
        var val2 = b[key]
        return val1 - val2
      }
    }
    watch(
      () => contentIndex.value,
      () => {
        swiper.value.swipeTo(contentIndex.value)

        document.title = contentTitle.value
      }
    )
    watch(contentList.value, () => {
      swiper.value.swipeTo(areaIndex.value)
      document.title = contentTitle.value
      videoElement.value = document.getElementsByTagName('audio')
    })
    watch(
      () => contentTitle.value,
      () => {
        document.title = contentTitle.value
      })
    // watch(
    //   () => directoryList.value,
    //   () => {
    //     contentList.value = []
    //     if (directoryList.value !== undefined) {
    //       contentDirectoryList.value = directoryList.value
    //     }
    //     console.log(emitDirectoryList.value)
    //     contentTitleList.value = []
    //     contentDirectoryList.value.map((item, index) => {
    //       const contentItem = {
    //         contentIndex: index,
    //         title: item.title
    //       }
    //       contentTitleList.value.push(contentItem)
    //       document.title = item.title
    //       newsId.value = route.params.newsid
    //       console.log(newsId.value)
    //       if (item.id === newsId.value) {
    //         areaIndex.value = index
    //         title.value = item.title
    //         store.dispatch('getActiveIndex', index)
    //       }
    //       getContentText(item.id, item.accessName)
    //     })
    //   }
    // )
    // const handleClickSwiperItem = (e) => {
    //   const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
    //   const add = 'content__icon__wrapper'
    //   document.addEventListener('click', (e) => {
    //     if (add && add.indexOf(e.target)) {
    //       debugger
    //       contentNode.style.fontSize = 22 + 'px'
    //     }
    //   })
    //   // debugger
    // }
    const backTop = (e) => {
      e.target.offsetParent.nextElementSibling.lastChild.scrollTo(0, 0)
    }
    const changeFontSizeAdd = (e) => {
      const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
      if (count.value < 0.57) {
        count.value += 0.05
        contentNode.style.fontSize = count.value + 'rem'
      }
    }
    const changeFontSizeSubtract = (e) => {
      const contentNode = e.target.offsetParent.nextElementSibling.lastChild.lastChild
      if (count.value > 0.47) {
        count.value -= 0.05
        contentNode.style.fontSize = count.value + 'rem'
      }
    }
    const routeBack = () => {
      router.back()
    }
    const changePrev = () => {
      swiper.value.prev()
      for (let i = 0; i < videoElement.value.length; i++) {
        if (i > 0 && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
    }
    const changeNext = () => {
      swiper.value.next()
      for (let i = 0; i < videoElement.value.length; i++) {
        if (i > 0 && i === changeIndex.value) {
          videoElement.value[i].pause()
          store.dispatch('getVoiceState', true)
        }
      }
    }
    return {
      contentText,
      content,
      voiceText,
      typeName,
      contentList,
      attachedPictures,
      text,
      swiper,
      imgUrl,
      periodical,
      newspaperId,
      newspaper,
      swiperIndex,
      showHeight,
      backTop,
      routeBack,
      changePrev,
      changeNext,
      changeFontSizeAdd,
      changeFontSizeSubtract,
      getDailyPageList,
      onChange,
      getContentDirectory,
      // 图片缩放相关
      scale: 1, // 初始缩放比例
      startX: 0, // 触摸开始时的 X 坐标
      startY: 0, // 触摸开始时的 Y 坐标
      lastX: 0, // 上一次触摸移动时的 X 坐标
      lastY: 0, // 上一次触摸移动时的 Y 坐标
      pinching: false, // 是否正在执行缩放操作
      maxScale: 4, // 最大缩放比例
      minScale: 0.5 // 最小缩放比例
    }
  },
  methods: {
    handleTouchStart (event) {
      if (event.touches.length === 2) { // 双指触摸开始缩放
        this.pinching = true
        this.startX = event.touches[0].clientX - event.touches[1].clientX
        this.startY = event.touches[0].clientY - event.touches[1].clientY
        this.lastX = this.startX
        this.lastY = this.startY
      }
    },
    handleTouchMove (event) {
      if (!this.pinching || event.touches.length !== 2) return // 不是缩放操作或触摸点数量不正确，直接返回
      const newX = event.touches[0].clientX - event.touches[1].clientX
      const newY = event.touches[0].clientY - event.touches[1].clientY
      const deltaX = newX - this.lastX
      const deltaY = newY - this.lastY
      // 计算新的缩放比例（这里只是简单示例，实际可能需要更复杂的计算）
      this.scale += (deltaY - deltaX) * 0.1
      // 限制缩放比例的范围
      this.scale = Math.min(Math.max(this.minScale, this.scale), this.maxScale)
      // 更新上一次触摸的坐标
      this.lastX = newX
      this.lastY = newY
    },
    handleTouchEnd () {
      this.pinching = false // 结束缩放操作
    }
  }
}
</script>

<style lang="scss" scoped>

/* Vue 3 深度选择器写法 */
.left-align-text :deep(*) {
  text-align: left !important;
}

.content{
  position: relative;
  width: 100%;
  .content__text{
    font-size: .5rem;
    height: 100%;
    text-align: justify;
    overflow-y: auto;
    padding: .4rem .4rem;
    box-sizing: border-box;
    line-height: .8rem;
    &__h3{
      margin: 0;
      text-align: center;
    }
    &__h4{
      margin: 0;
      text-align: center;
    }
    &__p{
      color: #777777;
      font-size: 16px;
      border-bottom: 1px solid #dddddd;
      span{
        margin-right: 6px;
      }
    }
    &__author{
      color: #777777;
      font-size: 16px;
      text-align: center;
    }
    &__img{
      width: 90%;
      margin: 0 auto;
      text-align: center;
      img{
        width: 100%;
        margin-bottom: 10px;
      }
      p{
        font-size: 14px;
      }
    }
    &__content >>> p{
      margin: 0;
    }
  }
  &__item{
    height: 100%;
    overflow-y: auto;
  }
  &__icon{
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    &__wrapper{
      display: inline-block;
      width: 45px;
      height: 45px;
      line-height: 43px;
      border-radius: 50%;
      background-color: #DE1B23;
      text-align: center;
      opacity: 0.5;
      vertical-align: middle;
      &__item{
        color: #ffffff;
        font-size: 0.6rem;
      }
    }
   .left{
     margin-right: 0.5rem;
   }
  }
  &__left{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    left: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    transform: rotate(180deg);
    opacity: 0.6;
  }
  &__next{
    width: 1.5rem;
    height: 1.5rem;
    top: 50%;
    right: 0.3rem;
    position: absolute;
    background-image: url('../../../public/img/next.png');
    background-size: 100% 100%;
    opacity: 0.6;
  }

}
// 图片手势缩放相关
.image-container {
  overflow: hidden; /* 隐藏超出容器的图片部分 */
  touch-action: none; /* 阻止默认的触摸行为 */
}
.image-container img {
  transition: transform 0.3s ease; /* 添加过渡效果 */
  user-select: none; /* 禁止用户选择图片内容 */
}
</style>
